import React from 'react';
import ReactDOM from 'react-dom';
import ScheduleAppointmentForm from './ScheduleAppointmentForm';
import '../styles/Modal.css';

function AppointmentModal({ isOpen, onClose, appointment, preSelectedPatientId, preSelectedDate, isScheduleMode }) {
  if (!isOpen) return null;

  const isEditMode = !!appointment;

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {isEditMode
              ? "Edit Appointment"
              : "Schedule Appointment"}
          </h2>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          <ScheduleAppointmentForm
            onSuccess={onClose}
            preSelectedDate={preSelectedDate}
            appointment={appointment}
            preSelectedPatientId={preSelectedPatientId}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}

export default AppointmentModal;
